import { OTAService } from '@/core/services/ota'
import { addSentryBreadCrumb } from '@/utils/sentry'

export const getCountriesFetcher = async () => {
  const response = await OTAService.getCountries()

  addSentryBreadCrumb({ breadCrumbName: 'fetch: OTAService.getCountries()', object: { countries: response } })

  return response
}
